import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
import { DEFAULT_OPTIONS } from '../../store/defaultOptions';

export const SelectStyleCodeLabel = ({initialId, callback}) => {
    const configs = DEFAULT_OPTIONS.style_code_label
    const [selectedValue, setSelectedValue] = useState((initialId));

    function onSelect(event) {
        let value = event.target.value
        setSelectedValue(value)
        callback(value)
    }
    
    return (
        <div>
            <select className="form-select" value={initialId ?? configs[0].id} onChange={onSelect} name='neck_label'>
            { configs.map((e) => {return (  <option key={e.id} value={e.id}>{e.name}</option>  )}) }
            </select>
        </div>
    )
}
